import { getTranslation } from "./i18n";
import SettingsPersistor from "./settings-persistor";

export default class SliderCreator
{
  public static createSlider (moduleName: string, min: number, max: number, step: number, value: number, initial: number) {
    return `
    <div class="a11y-controls">
      <button class="a11y-minus" id="a11y-${moduleName}-minus" type="button" class="disabled" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-minus" data-translation-aria-field="true" data-translation-key="decreaseAria" aria-label="${getTranslation('decreaseAria')}">
        -
      </button>
      <div class="a11y-range a11y-settings__range-group range-group">
        <input id="a11y-${moduleName}" data-initial="${initial}" class="range-group__input" type="range" min="${min}" max="${max}" step="${step}" value="${value}">
        <!-- <div class="range-group__marker range-group__marker--zero" style="--marker-pos:0%"></div> -->
      </div>
      <button class="a11y-plus" id="a11y-${moduleName}-plus" type="button" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-plus" data-translation-aria-field="true" data-translation-key="increaseAria" aria-label="${getTranslation('increaseAria')}">
        +
      </button>
      <button class="a11y-reset" id="a11y-${moduleName}-reset" type="button" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-reset" data-translation-aria-field="true" data-translation-key="resetAria" aria-label="${getTranslation('resetAria')}"><span class="a11y-reset-icon">&#10226;</span></button>
    </div>
    `;
  }

  public static createSliderListeners (moduleName: string) {
    const slider = <HTMLInputElement> document.getElementById(`a11y-${moduleName}`);
    const plusBtn = <HTMLButtonElement> document.getElementById(`a11y-${moduleName}-plus`);
    const minusBtn = <HTMLButtonElement> document.getElementById(`a11y-${moduleName}-minus`);
    const resetBtn = <HTMLButtonElement> document.getElementById(`a11y-${moduleName}-reset`);

    const initialVal = slider.dataset.initial;

    const updateState = () => {
      const value = parseFloat(slider?.value);

      // TODO: Change this strucutre to use custom events instead of if-statements | Handle custom events per module
      if (moduleName === 'cursor-size') {
        document.documentElement.classList.remove('cursor-L');
        document.documentElement.classList.remove('cursor-XL');
        document.documentElement.classList.remove('cursor-XXL');

        let cursorSize: string;
        switch (value) {
          case 4:
            cursorSize = 'XXL';
            break;
          case 3:
            cursorSize = 'XL';
            break;
          case 2:
            cursorSize = 'L';
            break;
          case 1:
          default:
            cursorSize = 'default';
            break;
        }

        if (cursorSize != 'default') {
          document.documentElement.classList.add('cursor-' + cursorSize);
        }
      } else {
        document.documentElement.style.setProperty(`--accessibility-${moduleName}`, String(value));
      }

      const min = parseFloat(slider?.min);
      const max = parseFloat(slider?.max);

      plusBtn.disabled = value >= max;
      minusBtn.disabled = value <= min;

      plusBtn?.classList.toggle("disabled", plusBtn.disabled);
      minusBtn?.classList.toggle("disabled", minusBtn.disabled);

      SettingsPersistor.save(moduleName, value);

      if (moduleName == 'line-height' || moduleName == 'font-size') {
        window.dispatchEvent(new CustomEvent('a11y-update'));
      }
    };

    slider?.addEventListener("input", updateState);

    plusBtn?.addEventListener("click", () => {
      let current = parseFloat(slider.value);
      const step = parseFloat(slider.step);
      const max = parseFloat(slider.max);

      if (current < max) {
        slider.value = (Math.min(current + step, max)).toFixed(2);
        updateState();
      }
    });

    minusBtn.addEventListener("click", () => {
      let current = parseFloat(slider?.value);
      const step = parseFloat(slider?.step);
      const min = parseFloat(slider?.min);

      if (current > min) {
        slider.value = (Math.max(current - step, min)).toFixed(2);
        updateState();
      }
    });

    resetBtn.addEventListener("click", () => {
      slider.value = initialVal ?? '';
      updateState();
    });

    updateState();
  }
}